import { Poller } from './Poller';

export type PollingParams = {
  name: string;
  callback?: Function;
  url?: string;
  interval?: number;
  useTimestamp?: boolean;
  timestamp?: string;
  serviceFunction?: () => Promise<any>;
  enableBackoffInterval?: boolean;
  cancelUrl?: string;
  requestID?: string;
  csrfToken?: string;
};

export class PollingManager {
  pollers: Record<string, Poller> = {};

  register({
    name,
    callback,
    url,
    interval,
    useTimestamp,
    timestamp,
    enableBackoffInterval,
    serviceFunction,
    cancelUrl,
    requestID,
    csrfToken,
  }: PollingParams) {
    if (this.pollers[name]) {
      this.pollers[name].stop();
      delete this.pollers[name];
    }

    this.pollers[name] = new Poller({
      name,
      callback,
      url,
      interval,
      useTimestamp,
      timestamp,
      enableBackoffInterval,
      serviceFunction,
      cancelUrl,
      requestID,
      csrfToken,
    });

    this.pollers[name].run();
  }

  destroy(name: string) {
    if (this.pollers[name]) {
      this.pollers[name].stop();
      delete this.pollers[name];
    }
  }

  destroyAll() {
    const registeredPollers = Object.keys(this.pollers);

    if (registeredPollers.length > 0) {
      registeredPollers.forEach((name: string) => {
        this.destroy(name);
      });
    }
  }

  terminate(name: string) {
    if (this.pollers[name]) {
      const { cancelUrl, requestID, csrfToken } = this.pollers[name];
      if (cancelUrl && requestID && csrfToken) {
        const data = new FormData();
        data.append('csrfmiddlewaretoken', csrfToken);
        data.append('request_id', requestID);

        navigator.sendBeacon(cancelUrl, data);
      }
      this.destroy(name);
    }
  }
}
